import TabRoot, { Props } from './Tab'

export type { Props }

export default function Tab(props: Props) {
  return <TabRoot {...props} />
}
